require("bootstrap");
require("./app");

// slide
import Splide from "@splidejs/splide";

require("@fancyapps/fancybox");
require("slick-carousel");
require("./belmonte/js-slider.min");
require("./modal_promocion");
require("./icono_cercano");
require("./components/conversemos");
require("./components/banner_promocion_04_24");


$(document).ready(function () {
    $("#abre-menu").on("click", function () {
        $("#abre-menu").toggleClass("activo");
    });

    const slide_atributos = new Splide("#slide-atributos", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        arrows: true,
        pagination: false,
        breakpoints: {
            992: {
                perPage: 4
            },
            768: {
                perPage: 3
            }
        }
    }).mount();

    slide_atributos.on("active", function (e) {
        const titulo = $(e.slide)
            .find(".slide-in")
            .data("titulo");
        const texto = $(e.slide)
            .find(".slide-in")
            .data("texto");
        const imagen = $(e.slide)
            .find(".slide-in")
            .data("imagen");
        $("#atributos")
            .find("h3")
            .html(titulo);
        $("#atributos")
            .find("p")
            .html(texto);
        $("#atributos")
            .find(".fondo")
            .css("background-image", `url(${imagen})`);
    });

    //Slide Galeria Exterior
    $("#galeria-exterior .exterior").slick({
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        nextArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-next">&rsaquo;</a>',
        prevArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-prev">&lsaquo;</a>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    //Slide Galereia Atributos
    $("#galeria_atrivutos1 .galeria").slick({
        arrows: true,
        autoplay: true,
        dots: false,
        fade: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        nextArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-prev"><img src="../images/proyectos/boton_flecha_derecha.svg"/></a>',
        prevArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-next"><img src="../images/proyectos/boton_flecha_izquierda.svg"/></a>',

    });

    $("#galeria_atrivutos2 .galeria").slick({
        arrows: true,
        autoplay: true,
        dots: false,
        fade: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        nextArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-prev"><img src="../images/proyectos/boton_flecha_derecha.svg"/></a>',
        prevArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-next"><img src="../images/proyectos/boton_flecha_izquierda.svg"/></a>',

    });

    // Slide Galeria interior
    $("#galeria-interior .interior").slick({
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        nextArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-next">&rsaquo;</a>',
        prevArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-prev">&lsaquo;</a>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(".js-slider-container").slider();

    //SLIDE INICIO
    $("#modelos .galeria-modelo").slick({
        arrows: false,
        autoplay: true,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 4
    });
});

$('#en-promocion-getnet').find('.cerrar-promo').on('click', function () {
    $('#en-promocion-getnet').toggleClass('close');
})
require("./modal_promocion");
